// extracted by mini-css-extract-plugin
export default {"component":"Footer_component__tShEH","dataProtectionLink":"Footer_dataProtectionLink__4GaEg","cookiesSettingsP":"Footer_cookiesSettingsP__Iniwo"};